(function () {
  function initMbbSection(root) {
    var filters = root.querySelectorAll('.mbb-filter[data-mbb-filter]');
    var cards = root.querySelectorAll('.mbb-card[data-mbb-benefits]');
    var empty = root.querySelector('.mbb-empty');
    if (!filters.length || !cards.length) return;

    var animating = false;

    function applyFilter(handle) {
      if (animating) return;
      animating = true;

      // Phase 1: fade out all currently visible cards
      var visibleCards = [];
      cards.forEach(function (card) {
        if (!card.classList.contains('is-hidden')) {
          visibleCards.push(card);
          card.classList.add('is-exiting');
        }
      });

      setTimeout(function () {
        var visible = 0;

        // Phase 2: update which cards are shown
        cards.forEach(function (card) {
          card.classList.remove('is-exiting');
          var benefits = (card.getAttribute('data-mbb-benefits') || '')
            .split(',')
            .map(function (s) { return s.trim(); })
            .filter(Boolean);
          var show = !handle || handle === 'all' || benefits.indexOf(handle) !== -1;

          if (show) {
            // Pre-set entering state before removing is-hidden so we can animate in
            card.style.opacity = '0';
            card.style.transform = 'translateY(6px)';
            card.classList.remove('is-hidden');
            visible += 1;
          } else {
            card.classList.add('is-hidden');
          }
        });

        if (empty) empty.hidden = visible > 0;

        // Phase 3: trigger fade-in on next frame
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            cards.forEach(function (card) {
              if (!card.classList.contains('is-hidden')) {
                card.style.opacity = '';
                card.style.transform = '';
              }
            });
            animating = false;
          });
        });
      }, 200);
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-active')) return;
        filters.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        applyFilter(btn.getAttribute('data-mbb-filter'));
      });
    });
  }

  document.querySelectorAll('[data-mbb-section]').forEach(initMbbSection);
})();
